// Fetches the videos in a YouTube playlist (requires a YouTube Data API
// key configured in the theme's custom settings), picks one at random to
// feature, and fills the sidebar with the rest as clickable links.
// Without an API key, or if the request fails, the server-rendered
// playlist embed is left untouched.
const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours

function readCache(cacheKey) {
    try {
        const cached = JSON.parse(localStorage.getItem(cacheKey));
        if (cached && (Date.now() - cached.time) < CACHE_TTL) {
            return cached.items;
        }
    } catch (error) {
        // Ignore unavailable/corrupt localStorage (private browsing, etc).
    }
    return null;
}

function writeCache(cacheKey, items) {
    try {
        localStorage.setItem(cacheKey, JSON.stringify({time: Date.now(), items}));
    } catch (error) {
        // Ignore storage quota/availability errors.
    }
}

async function fetchPlaylistItems(playlistId, apiKey) {
    const cacheKey = `dc506_talks_${playlistId}`;
    const cached = readCache(cacheKey);
    if (cached) {
        return cached;
    }

    const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=12&playlistId=${encodeURIComponent(playlistId)}&key=${encodeURIComponent(apiKey)}`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`YouTube API responded with ${response.status}`);
    }

    const data = await response.json();
    const items = (data.items || [])
        .filter((item) => item.snippet && item.snippet.resourceId && item.snippet.resourceId.videoId)
        .map((item) => ({id: item.snippet.resourceId.videoId, title: item.snippet.title}));

    writeCache(cacheKey, items);
    return items;
}

export default function talks() {
    const widget = document.querySelector('[data-talks-widget]');
    if (!widget) {
        return;
    }

    const player = widget.querySelector('[data-talks-player]');
    const list = widget.querySelector('[data-talks-list]');
    const playlistId = widget.getAttribute('data-playlist-id');
    const apiKey = widget.getAttribute('data-api-key');

    if (!player || !list || !playlistId || !apiKey) {
        return;
    }

    fetchPlaylistItems(playlistId, apiKey).then((items) => {
        if (!items.length) {
            return;
        }

        function play(link) {
            player.src = `https://www.youtube-nocookie.com/embed/${link.getAttribute('data-talk-id')}`;
            list.querySelectorAll('li').forEach((li) => li.classList.remove('is-active'));
            link.parentElement.classList.add('is-active');
        }

        items.forEach((item) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = `https://www.youtube.com/watch?v=${item.id}`;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = item.title;
            link.setAttribute('data-talk-id', item.id);
            link.addEventListener('click', function (event) {
                event.preventDefault();
                play(link);
            });
            li.appendChild(link);
            list.appendChild(li);
        });

        const links = Array.from(list.querySelectorAll('[data-talk-id]'));
        play(links[Math.floor(Math.random() * links.length)]);
    }).catch(() => {
        // Keep the server-rendered fallback embed in place.
    });
}
